module.exports = __webpack_public_path__ + "img/home.292126b5.svg";